import React from "react";

import { useParams } from "react-router-dom";

import ContentLayout from "Components/ContentLayout";
import Layout from "src/organization/pages/billing/components/Layout";

import List from "./containers/List";

const OrganizationBilling = () => {
  const { organizationId } = useParams();

  return (
    <Layout>
      <ContentLayout id="settings-billing" className="settings-content">
        <List organizationId={organizationId} />
      </ContentLayout>
    </Layout>
  );
};

export default OrganizationBilling;
